import React from 'react';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import Fade from '@mui/material/Fade';

function SectionLoader({ delay }: { delay?: string }) {
  return (
    <Box height="100%" display="flex" alignItems="center" justifyContent="center">
      <Fade
        in
        style={{
          transitionDelay: delay ? delay : '0',
        }}
      >
        <CircularProgress role="progressbar" title="Loading..." />
      </Fade>
    </Box>
  );
}

export default SectionLoader;
